//@flow
import React from 'react';
import {Switch} from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';

import type {SwitchProps} from '@material-ui/core';
import {classNames} from '../../utils/react';

const useStyles = makeStyles(theme => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 4,
    '&$checked': {
      transform: 'translateX(16px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: '#00B382',
        opacity: 1,
        // border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: '#52d869',
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: 18,
    height: 18,
  },
  track: {
    borderRadius: 26 / 2,
    // border: `1px solid white`,
    backgroundColor: '#b8b8c7',
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}));

export default function IosSwitch(props: SwitchProps) {
  const {classes: switchClasses, ...restProps} = props;
  const classes = useStyles();

  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classNames(classes.root, switchClasses?.root),
        switchBase: classNames(classes.switchBase, switchClasses?.switchBase),
        thumb: classNames(classes.thumb, switchClasses?.thumb),
        track: classNames(classes.track, switchClasses?.track),
        checked: classNames(classes.checked, switchClasses?.checked),
      }}
      {...restProps}
    />
  );
}
